import classNames from "classnames";
import { NavLink, useMatch } from "react-router";
import { Glyph } from "../types";
// import GarageHome from "./icons/garage_home.svg?react";
// import GarageHomeFilled from "./icons/garage_home_filled.svg?react";
import Icon from "./Icon";
import RocketLaunch from "./icons/rocket_launch.svg?react";
import RocketLaunchFilled from "./icons/rocket_launch_filled.svg?react";
import SportsMotorsports from "./icons/sports_motorsports.svg?react";
import SportsMotorsportsFilled from "./icons/sports_motorsports_filled.svg?react";
import Tune from "./icons/tune.svg?react";
import styles from "./Navbar.module.css";

const Navbar = () => {
  return (
    <nav>
      <ul className={styles.menu}>
        <li>
          <MenuItem
            to="/setups"
            text="Setups"
            activeIcon={Tune}
            inactiveIcon={Tune}
          />
        </li>
        {/* <li>
          <MenuItem
            to="/garage"
            activeIcon={GarageHomeFilled}
            inactiveIcon={GarageHome}
          />
        </li> */}
        <li>
          <MenuItem
            to="/how-to"
            text="How-To"
            activeIcon={RocketLaunchFilled}
            inactiveIcon={RocketLaunch}
          />
        </li>
        <li>
          <MenuItem
            to="/profile"
            text="Profile"
            activeIcon={SportsMotorsportsFilled}
            inactiveIcon={SportsMotorsports}
          />
        </li>
      </ul>
    </nav>
  );
};

interface MenuItemProps {
  to: string;
  text: string;
  activeIcon: Glyph;
  inactiveIcon: Glyph;
}

const MenuItem = ({ to, text, activeIcon, inactiveIcon }: MenuItemProps) => {
  const match = useMatch({ path: to, end: false });

  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        classNames(styles.menuItem, {
          [styles.active]: isActive,
        })
      }
    >
      <div className={styles.iconWrapper}>
        <Icon
          glyph={match ? activeIcon : inactiveIcon}
          className={styles.icon}
        />
      </div>
      <span className={styles.iconText}>{text}</span>
    </NavLink>
  );
};

export default Navbar;
